<main>
  @if ((orderStatus$ | async) !== OrderStatus.PENDING) {
    <h2 class="ps-xlarge-t ms-large-b nordic-blue-900-text bold-type">
      <span>{{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.title' | finLocalization }}</span>
    </h2>
    <div
      class="font-body-1 regular-type"
      [innerHTML]="
        'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.description'
          | finLocalization: { origin: (departure$ | async), destination: (arrival$ | async) }
      "
    ></div>
    <div class="font-body-1 medium-type border white-bg rounded-large ms-large-t ps-large">
      <h3 class="font-heading-4 ps-medium-b">
        {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.title' | finLocalization }}
      </h3>
      <div class="line-list-container ps-large-x fill g-medium">
        <ul class="no-list-style flex flex--wrap">
          <li class="flex ps-medium-y">
            <fcom-icon class="icon-medium flex--shrink0" [name]="SvgLibraryIcon.ONE_BLOCK" />
            <div class="ms-xsmall-l flex flex--column">
              <div>{{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.confirm' | finLocalization }}</div>
              <div class="font-body-2 regular-type ps-small-t">
                {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.confirmDetail' | finLocalization }}
              </div>
            </div>
          </li>
          <li class="flex ps-medium-b">
            <fcom-icon class="icon-medium flex--shrink0" [name]="SvgLibraryIcon.TWO_BLOCK" />
            <div class="ms-xsmall-l flex flex--column">
              <div>{{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.arrive' | finLocalization }}</div>
              <div class="font-body-2 regular-type"></div>
            </div>
          </li>
          <li class="flex ps-medium-b">
            <fcom-icon class="icon-medium flex--shrink0" [name]="SvgLibraryIcon.THREE_BLOCK" />
            <div class="ms-xsmall-l flex flex--column">
              <div>{{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.wait' | finLocalization }}</div>
              <div class="font-body-2 regular-type ps-small-t">
                {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.checklist.waitDetail' | finLocalization }}
              </div>
            </div>
          </li>
        </ul>
      </div>
      <h3 class="font-heading-4 ps-medium-y">
        {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.title' | finLocalization }}
      </h3>
      <span class="font-body-1 regular-type">
        {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.detail' | finLocalization }}
      </span>
      <div class="ps-large-x ms-medium-y nordic-blue-25-bg rounded-large">
        <div class="flex flex--column ps-medium-y">
          <span class="font-body-1 bold-type">
            {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.rebook' | finLocalization }}
          </span>
          <span class="font-body-1 regular-type ms-small-t">
            {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.rebookDetail' | finLocalization }}
          </span>
        </div>
        <span class="font-body-1 bold-type">
          {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.compensation.title' | finLocalization }}
        </span>
        <ul class="ps-large-x ms-small-t ps-medium-b">
          <li
            class="font-body-1 regular-type"
            data-testid="compensation-amount"
            [innerHTML]="
              'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.compensation.amount'
                | finLocalization
                  : {
                      giftCard: (compensation$ | async)?.giftCard,
                      monetary: (compensation$ | async)?.monetary,
                      avios: (compensation$ | async)?.avios | finPoints,
                    }
            "
          ></li>
        </ul>
        <span class="font-body-1 regular-type">
          {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.compensation.receive' | finLocalization }}
        </span>
        <div class="ms-medium-t">
          <span class="font-body-1 bold-type">
            {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.addition.title' | finLocalization }}
          </span>
          <ul class="ps-large-x ms-small-t ps-medium-b">
            <li
              class="font-body-1 regular-type"
              [innerHTML]="
                'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.addition.sameDayBenefit'
                  | finLocalization
                  | finSafe: 'html'
              "
            ></li>
            <li
              class="font-body-1 regular-type"
              [innerHTML]="
                'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.addition.nextDayBenefit'
                  | finLocalization
                  | finSafe: 'html'
              "
            ></li>
          </ul>
        </div>
      </div>
      <fcom-link
        data-testid="read-more-voluntary-denied-boarding"
        class="bold-type nordic-blue-900-text font-body-1"
        [href]="'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.readMore.link.url' | finLocalization"
        [external]="true"
        [openInNewTab]="true"
        [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
      >
        {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.whatsNext.readMore.link.text' | finLocalization }}
      </fcom-link>
    </div>
    <div class="font-body-1 medium-type border white-bg rounded-large ms-large-t ps-large">
      <h3 class="font-heading-4">
        {{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.confirm.title' | finLocalization }}
      </h3>
      <form [formGroup]="confirmForm" class="flex flex--column ms-medium-t">
        <fcom-radio-item-group
          [options]="[
            { label: 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.confirm.yes', value: 'true' },
            { label: 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.confirm.no', value: 'false' },
          ]"
          [parentForm]="confirmForm"
          controlName="confirmChoice"
          [isRequired]="true"
          [theme]="RadioButtonTheme.ROUND"
          [titleText]="true"
        />
      </form>
    </div>

    <fcom-cta-button
      [loading]="loading$ | async"
      [title]="'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.button.title' | finLocalization"
      [disabled]="confirmForm.invalid"
      [position]="ButtonPosition.GRID_FULL"
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      (buttonClicked)="confirmVoluntaryDeniedBoarding()"
    >
      <span class="gray-50-text"
        >{{ 'MMB.checkIn.funnel.steps.voluntaryDeniedBoarding.button.description' | finLocalization }}
      </span>
    </fcom-cta-button>
  } @else {
    <div class="align-center fill">
      <fcom-loader aria-live="polite" [paragraph]="'MMB.checkIn.loadingOrder'" />
    </div>
  }
</main>
